<!-- Back to top button-->
<a (click)="scrollTop()" [ngClass]="buttonClass" class="btn-scroll-top" role="button" data-scroll>
  <svg viewBox="0 0 40 40" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <circle #svgCircle [ngStyle]="svgCircleStyle" cx="20" cy="20" r="19" fill="none" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10"></circle>
  </svg><i class="ai-arrow-up"></i>
</a>
